import { Tag } from "../types/tag"

type TagFilterInput = any

export const groupTags = (tags: Tag[]): TagFilterInput[] => {
  const tagList: TagFilterInput[] = []
  for (const tag of tags) {
    const item = tagList.find((x) => x.key === (tag.key ?? tag.categoryCode))
    if (item) {
      item.codes.push(tag.code)
    } else {
      tagList.push({
        key: tag.key ?? tag.categoryCode,
        codes: [tag.code],
      })
    }
  }
  return tagList
}
